import React, { useRef, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import './AuctionItem.css';

import { motion, AnimatePresence } from "framer-motion";


const BidHistory = ({ bids }) => {
  const bidHistoryBoxRef = useRef(null); 
  const nodeRefs = useRef([]); // Create an array of refs for each bid item
  const lastBidRef = useRef(null); 

  const reversedBids = bids.slice().reverse();

  

  
  

  return (
    <div className="fade-wrapper">
      <div className="bid-history-box" ref={bidHistoryBoxRef} id = "bid-history-box-id">
        <TransitionGroup>
          {reversedBids.map((bid, index) => {
            // Assign a unique ref for each bid item
            if (!nodeRefs.current[index]) {
              nodeRefs.current[index] = React.createRef();
            }

            return (
              <CSSTransition
                nodeRef={nodeRefs.current[index]} // Attach the correct nodeRef for each item
                key={bid.timestamp} 
                classNames="bid"
                timeout={500} // Add transition timeout if needed
              >
                <div ref={nodeRefs.current[index]} className="bid-wrapper">
                  <div
                    ref={index === 0 ? lastBidRef : null} // Only assign lastBidRef to the most recent bid
                    className={`bid-item ${index === 0 ? 'recent-bid' : ''}`}
                  >
                    <span className='bid-timestamp'>{new Date(bid.timestamp).toLocaleTimeString()}</span>
                    <p>{bid.name}: <strong>${bid.amount}</strong></p>
                  </div>
                </div>
              </CSSTransition>
            );
          })}
        </TransitionGroup>
      </div>
    </div>
  );

  
};

export default BidHistory;
